import { Controller } from "@hotwired/stimulus"

// Dropdown controller for Plantafel "New" menu
// Separate from tailwindcss-stimulus-components Dropdown to add close-on-click functionality
export default class extends Controller {
  static targets = ["menu"]

  connect() {
    // Close dropdown when clicking outside
    this.boundClickOutside = this.clickOutside.bind(this)
    // Use capture phase to ensure we catch the event before it's stopped
    document.addEventListener("click", this.boundClickOutside, true)

    // Also close on Escape key
    this.boundKeydown = this.keydown.bind(this)
    document.addEventListener("keydown", this.boundKeydown)
  }

  disconnect() {
    document.removeEventListener("click", this.boundClickOutside, true)
    document.removeEventListener("keydown", this.boundKeydown)
  }

  toggle(event) {
    event.stopPropagation()
    if (this.hasMenuTarget) {
      // Close all other plantafel dropdowns first
      document.querySelectorAll('[data-plantafel-new-dropdown-target="menu"]').forEach((menu) => {
        if (menu !== this.menuTarget) {
          menu.classList.add("hidden")
        }
      })

      this.menuTarget.classList.toggle("hidden")
    }
  }

  close() {
    if (this.hasMenuTarget) {
      this.menuTarget.classList.add("hidden")
    }
  }

  clickOutside(event) {
    // Check if the click is outside this dropdown element
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }

  keydown(event) {
    if (event.key === "Escape") {
      this.close()
    }
  }
}
